/*!
 * Lutterloh Vorführtermine: Terminseite und Startseiten-Widget.
 * Vanilla JS ohne Abhängigkeiten. Init idempotent, auch bei shopify:section:load.
 * "Heute" wird im Browser für Europe/Berlin berechnet, damit gecachtes HTML stimmt.
 * Test: ?vt_heute=YYYY-MM-DD überschreibt das Datum (nur hier im JS).
 */
(function () {
  'use strict';

  if (window.LutterlohVT) {
    window.LutterlohVT.initAll(document);
    return;
  }

  var DAY = 864e5;
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var hasProp = !!(window.CSS && window.CSS.registerProperty);

  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function on(el, type, fn, opts, cleanup) {
    if (!el) return;
    el.addEventListener(type, fn, opts || false);
    cleanup.push(function () { el.removeEventListener(type, fn, opts || false); });
  }

  /* ---------- Datum ---------- */
  function todayISO() {
    var m = /[?&]vt_heute=(\d{4}-\d{2}-\d{2})(?:&|$)/.exec(window.location.search);
    if (m) return m[1];
    try {
      var o = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date())
        .forEach(function (p) { o[p.type] = p.value; });
      if (o.year && o.month && o.day) return o.year + '-' + o.month + '-' + o.day;
    } catch (e) { /* ältere Browser: lokales Datum */ }
    var d = new Date();
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function utc(iso) { var p = iso.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function daysBetween(a, b) { return Math.round((utc(b) - utc(a)) / DAY); }

  function statusOf(start, end, today) {
    if (!start || !end || end < today) return null;
    if (start === today) return { text: 'Heute', kind: 'today', live: true };
    if (start < today) return { text: 'Läuft gerade', kind: 'live', live: true };
    var d = daysBetween(today, start);
    if (d === 1) return { text: 'Morgen', kind: 'soon' };
    if (d < 14) return { text: 'In ' + d + ' Tagen', kind: 'soon' };
    if (d < 60) return { text: 'In ' + Math.round(d / 7) + ' Wochen', kind: 'later' };
    var mo = Math.round(d / 30.44);
    return { text: 'In ' + mo + (mo === 1 ? ' Monat' : ' Monaten'), kind: 'later' };
  }

  function setBadge(el, st) {
    if (!el) return;
    if (!st) { el.hidden = true; el.textContent = ''; return; }
    el.className = 'vt-badge vt-badge--' + st.kind;
    el.textContent = '';
    if (st.live) {
      var dot = document.createElement('span');
      dot.className = 'vt-dot';
      dot.setAttribute('aria-hidden', 'true');
      el.appendChild(dot);
    }
    el.appendChild(document.createTextNode(st.text));
    el.hidden = false;
  }

  /* Laufende Termine hervorheben, sonst den nächsten kommenden (nicht abgesagt). */
  function applyHighlight(items, today) {
    var running = items.filter(function (it) { return !it.cancelled && it.start <= today && it.end >= today; });
    var next = null;
    if (!running.length) {
      for (var i = 0; i < items.length; i++) {
        if (!items[i].cancelled && items[i].end >= today) { next = items[i]; break; }
      }
    }
    items.forEach(function (it) {
      var hl = running.indexOf(it) > -1 || it === next;
      if (it.hlEl) it.hlEl.classList.toggle('is-hl', hl);
      if (it.nextEl) it.nextEl.hidden = it !== next;
    });
  }

  /* ---------- Suche ---------- */
  function strip(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim();
  }
  function haystack(s) {
    var raw = String(s || '').toLowerCase();
    var translit = raw.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
    return strip(raw) + ' ' + strip(translit);
  }
  function matches(hay, terms) {
    for (var i = 0; i < terms.length; i++) { if (hay.indexOf(terms[i]) === -1) return false; }
    return true;
  }

  /* ---------- Kalenderdatei (RFC 5545) ---------- */
  function icsEscape(v) {
    return String(v).replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  }
  function utf8Len(ch) {
    var c = ch.codePointAt(0);
    return c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }
  function fold(line) {
    var out = '';
    var len = 0;
    Array.from(line).forEach(function (ch) {
      var l = utf8Len(ch);
      if (len + l > 75) { out += '\r\n '; len = 1; }
      out += ch;
      len += l;
    });
    return out;
  }
  function ymd(iso) { return iso.replace(/-/g, ''); }
  function nextDay(iso) {
    var d = new Date(utc(iso) + DAY);
    return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate());
  }
  function buildICS(row, desc) {
    var get = function (k) { return row.getAttribute('data-vt-' + k) || ''; };
    var handle = get('handle');
    var url = window.location.origin + window.location.pathname + '#termin-' + handle;
    var lines = [];
    if (desc) lines.push(desc);
    if (get('hours')) lines.push('Öffnungszeiten: ' + get('hours'));
    if (get('note')) lines.push('Hinweis: ' + get('note'));
    if (get('web')) lines.push('Messe-Website: ' + get('web'));
    lines.push('Details: ' + url);
    var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    var ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Modeverlag Lutterloh//Vorfuehrtermine//DE',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + handle + '@lutterloh-system.de',
      'DTSTAMP:' + stamp,
      'DTSTART;VALUE=DATE:' + ymd(get('start')),
      'DTEND;VALUE=DATE:' + nextDay(get('end')),
      'SUMMARY:' + icsEscape('Lutterloh Vorführung: ' + get('title') + ' ' + get('city')),
      'LOCATION:' + icsEscape(get('place') || get('city')),
      'DESCRIPTION:' + icsEscape(lines.join('\n')),
      'URL:' + url,
      'STATUS:CONFIRMED',
      'TRANSP:TRANSPARENT',
      'END:VEVENT',
      'END:VCALENDAR'
    ];
    return ics.map(fold).join('\r\n') + '\r\n';
  }
  function download(name, text) {
    var blob = new Blob([text], { type: 'text/calendar;charset=utf-8' });
    var href = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = href;
    a.download = name;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(href); if (a.parentNode) a.parentNode.removeChild(a); }, 1500);
  }

  /* ---------- Einblenden beim Scrollen (nur was noch nicht sichtbar ist) ---------- */
  function setupReveal(root, cleanup) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var items = toArray(root.querySelectorAll('.vt-reveal'));
    if (!items.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var pending = [];
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-in', 'vt-static');
      else pending.push(el);
    });
    if (!pending.length) return;
    root.classList.add('vt-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    pending.forEach(function (el) { io.observe(el); });
    cleanup.push(function () { io.disconnect(); });
  }

  /* ---------- Terminseite ---------- */
  function initPage(root) {
    if (root.__vt) return;
    var cleanup = [];
    root.__vt = { destroy: function () { cleanup.forEach(function (fn) { try { fn(); } catch (e) { /* egal */ } }); } };
    if (hasProp) root.classList.add('vt-prop');

    var rows = toArray(root.querySelectorAll('[data-vt-card]')).map(function (el) {
      return {
        el: el,
        hlEl: el,
        handle: el.getAttribute('data-vt-handle'),
        start: el.getAttribute('data-vt-start') || '',
        end: el.getAttribute('data-vt-end') || '',
        land: el.getAttribute('data-vt-land') || '',
        cancelled: el.hasAttribute('data-vt-cancelled'),
        hay: haystack(el.getAttribute('data-vt-search')),
        statusEl: el.querySelector('[data-vt-status]'),
        nextEl: el.querySelector('[data-vt-next]'),
        up: false,
        show: false
      };
    });
    var arch = toArray(root.querySelectorAll('[data-vt-row]')).map(function (el) {
      return {
        el: el,
        handle: el.getAttribute('data-vt-row'),
        end: el.getAttribute('data-vt-end') || '',
        year: el.getAttribute('data-vt-year'),
        hay: haystack(el.getAttribute('data-vt-search')),
        past: false,
        show: false
      };
    });
    var tabs = toArray(root.querySelectorAll('[data-vt-tab]'));
    var tablist = root.querySelector('[data-vt-tabs]');
    var panels = toArray(root.querySelectorAll('[data-vt-panel]'));
    var chips = toArray(root.querySelectorAll('[data-vt-chip]'));
    var q = root.querySelector('[data-vt-q]');
    var clearBtn = root.querySelector('[data-vt-clear]');
    var resetBtn = root.querySelector('[data-vt-reset]');
    var filterWrap = root.querySelector('[data-vt-filter]');
    var table = root.querySelector('[data-vt-table]');
    var list = root.querySelector('[data-vt-list]');
    var none = root.querySelector('[data-vt-none]');
    var noneText = root.querySelector('[data-vt-none-text]');
    var empty = root.querySelector('[data-vt-empty]');
    var count = root.querySelector('[data-vt-count]');
    var result = root.querySelector('[data-vt-result]');
    var jump = root.querySelector('[data-vt-jump]');
    var jumpLabel = root.querySelector('[data-vt-jump-label]');
    var archive = root.querySelector('[data-vt-archive]');
    var archiveCount = root.querySelector('[data-vt-archive-count]');
    var archiveNone = root.querySelector('[data-vt-archive-none]');
    var desc = root.getAttribute('data-vt-ics-desc') || '';

    var selTab = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    var state = { land: '*', query: '', year: selTab ? selTab.getAttribute('data-vt-tab') : null, upCount: 0 };
    var lastShownKey = null;
    var swapTimer = null;
    var flashTimer = null;
    var qTimer = null;

    function computeDates() {
      var today = todayISO();
      var lands = {};
      var upRows = [];
      var active = 0;
      rows.forEach(function (r) {
        r.up = r.end >= today;
        if (r.up) {
          upRows.push(r);
          if (!r.cancelled) {
            active++;
            lands[r.land] = (lands[r.land] || 0) + 1;
          }
        } else {
          r.el.classList.remove('is-hl');
          if (r.nextEl) r.nextEl.hidden = true;
        }
        setBadge(r.statusEl, r.up && !r.cancelled ? statusOf(r.start, r.end, today) : null);
      });
      applyHighlight(upRows, today);
      arch.forEach(function (a) { a.past = a.end < today; });

      var multi = Object.keys(lands).length > 1;
      root.classList.toggle('vt-multi-land', multi);
      if (filterWrap) filterWrap.hidden = !multi;
      if (!multi || (state.land !== '*' && !lands[state.land])) state.land = '*';
      chips.forEach(function (ch) {
        var l = ch.getAttribute('data-vt-chip');
        var n = l === '*' ? active : (lands[l] || 0);
        ch.hidden = l !== '*' && !n;
        var nEl = ch.querySelector('[data-vt-n]');
        if (nEl) nEl.textContent = n;
      });
      state.upCount = upRows.length;
      if (count) {
        count.textContent = plural(active, 'Termin', 'Termine');
        count.hidden = active === 0;
      }
      if (jump) {
        jump.hidden = !active;
        if (jumpLabel) jumpLabel.textContent = active === 1 ? '1 kommender Termin' : active + ' kommende Termine';
      }
      if (q) q.placeholder = active ? 'Stadt oder Messe suchen' : 'Archiv durchsuchen';
      if (empty) empty.hidden = active > 0;
      if (table) table.hidden = upRows.length === 0;
    }

    function swapRows(shown, animate) {
      var key = shown.map(function (r) { return r.handle; }).join('|');
      var changed = key !== lastShownKey;
      lastShownKey = key;
      function doSwap() {
        rows.forEach(function (r) { r.el.hidden = !r.show; });
        if (animate && changed && !reduced()) {
          shown.forEach(function (r, i) {
            r.el.classList.add('is-in', 'vt-static');
            if (r.el.animate) {
              r.el.animate(
                [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
                { duration: 420, delay: Math.min(i, 8) * 45, easing: EASE, fill: 'backwards' }
              );
            }
          });
        }
      }
      clearTimeout(swapTimer);
      if (animate && changed && !reduced() && list && list.animate) {
        var fade = list.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out', fill: 'forwards' });
        swapTimer = setTimeout(function () { doSwap(); fade.cancel(); }, 140);
      } else {
        doSwap();
      }
    }

    function applyFilters(animate) {
      var terms = strip(state.query).split(' ').filter(Boolean);
      var searching = terms.length > 0;
      var shown = [];
      rows.forEach(function (r) {
        r.show = r.up && (state.land === '*' || r.land === state.land) && (!searching || matches(r.hay, terms));
        if (r.show) shown.push(r);
      });
      chips.forEach(function (ch) { ch.setAttribute('aria-pressed', String(ch.getAttribute('data-vt-chip') === state.land)); });

      var yearCounts = {};
      var pastTotal = 0;
      var pastMatch = 0;
      arch.forEach(function (a) {
        if (a.past) pastTotal++;
        a.show = a.past && (!searching || matches(a.hay, terms));
        if (a.show) { pastMatch++; yearCounts[a.year] = (yearCounts[a.year] || 0) + 1; }
      });
      var years = tabs.map(function (t) { return t.getAttribute('data-vt-tab'); }).filter(function (y) { return yearCounts[y]; });
      if (years.indexOf(state.year) === -1) state.year = years[0] || null;
      tabs.forEach(function (t) {
        var y = t.getAttribute('data-vt-tab');
        var n = yearCounts[y] || 0;
        var sel = y === state.year;
        t.hidden = !n;
        t.setAttribute('aria-selected', String(sel));
        t.tabIndex = sel ? 0 : -1;
        var nEl = t.querySelector('[data-vt-n]');
        if (nEl) nEl.textContent = n;
      });
      if (tablist) tablist.hidden = years.length === 0;
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-vt-panel') !== state.year; });
      arch.forEach(function (a) { a.el.hidden = !a.show; });
      if (archive) archive.hidden = pastTotal === 0;
      if (archiveCount) archiveCount.textContent = plural(pastTotal, 'Termin', 'Termine');
      swapRows(shown, animate);

      var filtered = searching || state.land !== '*';
      var nothing = searching && shown.length === 0 && pastMatch === 0;
      var showNone = state.upCount > 0 && filtered && shown.length === 0;
      if (archiveNone) archiveNone.hidden = !(searching && pastTotal > 0 && pastMatch === 0) || nothing;
      if (none) {
        var msg = searching && pastMatch > 0
          ? 'Kein kommender Termin gefunden. Passende vergangene Termine finden Sie unten im Archiv.'
          : 'Kein Termin gefunden.';
        if (showNone) {
          var wasHidden = none.hidden;
          none.hidden = false;
          if (noneText && (wasHidden || noneText.textContent !== msg)) {
            // Text erst nach dem Einblenden setzen, damit die Live-Region ansagt
            noneText.textContent = '';
            window.requestAnimationFrame(function () { noneText.textContent = msg; });
          }
        } else {
          none.hidden = true;
          if (noneText) noneText.textContent = '';
        }
      }
      if (result) {
        if (!filtered || showNone) {
          result.textContent = '';
        } else if (searching) {
          result.textContent = nothing
            ? 'Kein Termin gefunden.'
            : (shown.length + pastMatch) + ' Treffer: ' + shown.length + ' kommend, ' + pastMatch + ' im Archiv';
        } else {
          result.textContent = plural(shown.length, 'Termin', 'Termine') + ' in ' + state.land;
        }
      }
      if (clearBtn) clearBtn.hidden = !(q && q.value);
    }

    function selectYear(y, focusTab) {
      if (!y || y === state.year) {
        if (focusTab) focusTabFor(y);
        return;
      }
      state.year = y;
      applyFilters(false);
      if (focusTab) focusTabFor(y);
      var panel = panels.filter(function (p) { return p.getAttribute('data-vt-panel') === y; })[0];
      if (panel && panel.animate && !reduced()) {
        panel.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE });
      }
    }
    function focusTabFor(y) {
      var t = tabs.filter(function (x) { return x.getAttribute('data-vt-tab') === y; })[0];
      if (t) t.focus();
    }

    function resetSearch(all) {
      if (q) q.value = '';
      state.query = '';
      if (all) state.land = '*';
      applyFilters(true);
      if (q) q.focus();
    }

    function focusHash(smooth) {
      var id = '';
      try { id = decodeURIComponent((window.location.hash || '').slice(1)); } catch (e) { return; }
      if (!/^(termin|archiv)-/.test(id)) return;
      var handle = id.replace(/^(termin|archiv)-/, '');
      var target = null;
      var r = rows.filter(function (x) { return x.handle === handle; })[0];
      if (r && r.up) {
        if (!r.show) {
          state.land = '*';
          state.query = '';
          if (q) q.value = '';
          applyFilters(false);
        }
        target = r.el;
      } else {
        var a = arch.filter(function (x) { return x.handle === handle; })[0];
        if (a && a.past) {
          if (!a.show) { state.query = ''; if (q) q.value = ''; }
          state.year = a.year;
          applyFilters(false);
          target = a.el;
        }
      }
      if (!target) return;
      target.classList.add('is-in', 'vt-static');
      window.requestAnimationFrame(function () {
        try { target.scrollIntoView({ behavior: smooth && !reduced() ? 'smooth' : 'auto', block: 'center' }); } catch (e) { target.scrollIntoView(); }
        target.classList.remove('vt-flash');
        void target.offsetWidth;
        target.classList.add('vt-flash');
        clearTimeout(flashTimer);
        flashTimer = setTimeout(function () { target.classList.remove('vt-flash'); }, 2600);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (e) { /* egal */ }
      });
    }

    chips.forEach(function (ch) {
      on(ch, 'click', function () {
        state.land = ch.getAttribute('data-vt-chip');
        applyFilters(true);
      }, false, cleanup);
    });
    if (q) {
      on(q, 'input', function () {
        if (clearBtn) clearBtn.hidden = !q.value;
        clearTimeout(qTimer);
        qTimer = setTimeout(function () { state.query = q.value; applyFilters(true); }, 200);
      }, false, cleanup);
      on(q, 'keydown', function (e) {
        if (e.key === 'Escape' && q.value) { e.preventDefault(); resetSearch(false); }
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(qTimer); state.query = q.value; applyFilters(true); }
      }, false, cleanup);
    }
    on(clearBtn, 'click', function () { resetSearch(false); }, false, cleanup);
    on(resetBtn, 'click', function () { resetSearch(true); }, false, cleanup);
    tabs.forEach(function (t) {
      on(t, 'click', function () { selectYear(t.getAttribute('data-vt-tab'), false); }, false, cleanup);
    });
    on(tablist, 'keydown', function (e) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;
      var vis = tabs.filter(function (t) { return !t.hidden; });
      var idx = vis.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? vis.length - 1 : (idx + (e.key === 'ArrowRight' ? 1 : -1) + vis.length) % vis.length;
      selectYear(vis[n].getAttribute('data-vt-tab'), true);
    }, false, cleanup);
    on(jump, 'click', function (e) {
      var id = (jump.getAttribute('href') || '').slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      try { target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); } catch (err) { target.scrollIntoView(); }
      var h = target.querySelector('h2');
      if (h) { try { h.focus({ preventScroll: true }); } catch (err) { /* egal */ } }
    }, false, cleanup);
    on(root, 'click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-vt-ics]') : null;
      if (!btn || !root.contains(btn)) return;
      var row = btn.closest('[data-vt-card]');
      if (!row) return;
      download('lutterloh-vorfuehrung-' + row.getAttribute('data-vt-handle') + '.ics', buildICS(row, desc));
    }, false, cleanup);
    on(window, 'hashchange', function () { focusHash(true); }, false, cleanup);
    on(document, 'visibilitychange', function () {
      if (!document.hidden) { computeDates(); applyFilters(false); }
    }, false, cleanup);

    computeDates();
    applyFilters(false);
    setupReveal(root, cleanup);
    if (window.location.hash) setTimeout(function () { focusHash(true); }, 80);
  }

  /* ---------- Startseiten-Widget ---------- */
  function initWidget(root) {
    if (root.__vt) return;
    var cleanup = [];
    root.__vt = { destroy: function () { cleanup.forEach(function (fn) { try { fn(); } catch (e) { /* egal */ } }); } };
    if (hasProp) root.classList.add('vt-prop');

    var today = todayISO();
    var max = parseInt(root.getAttribute('data-vt-max'), 10) || 8;
    var kept = [];
    toArray(root.querySelectorAll('[data-vt-slide]')).forEach(function (s) {
      if ((s.getAttribute('data-vt-end') || '') < today) { s.parentNode.removeChild(s); return; }
      kept.push(s);
    });
    kept.forEach(function (s, i) { s.hidden = i >= max; });
    var visible = kept.slice(0, max);
    visible.forEach(function (s, i) { s.setAttribute('aria-label', (i + 1) + ' von ' + visible.length); });
    var items = visible.map(function (s) {
      return {
        el: s,
        hlEl: s.querySelector('[data-vt-hl-target]'),
        start: s.getAttribute('data-vt-start') || '',
        end: s.getAttribute('data-vt-end') || '',
        cancelled: s.hasAttribute('data-vt-cancelled'),
        nextEl: s.querySelector('[data-vt-next]')
      };
    });
    items.forEach(function (it) {
      setBadge(it.el.querySelector('[data-vt-status]'), it.cancelled ? null : statusOf(it.start, it.end, today));
    });
    applyHighlight(items, today);

    if (!visible.length) {
      var hint = root.querySelector('[data-vt-design-hint]');
      var region = root.querySelector('[data-vt-carousel]');
      if (root.getAttribute('data-vt-design') === 'true') {
        if (hint) hint.hidden = false;
        if (region) region.hidden = true;
      } else {
        var section = root.closest('.shopify-section');
        root.hidden = true;
        if (section) { section.hidden = true; section.style.display = 'none'; }
      }
      return;
    }
    setupReveal(root, cleanup);
    carousel(root, cleanup);
  }

  function carousel(root, cleanup) {
    var track = root.querySelector('[data-vt-track]');
    if (!track) return;
    var back = root.querySelector('[data-vt-back]');
    var fwd = root.querySelector('[data-vt-fwd]');
    var toggle = root.querySelector('[data-vt-toggle]');
    var thread = root.querySelector('[data-vt-progress]');
    var autoplay = root.getAttribute('data-vt-autoplay') === 'true';
    var delay = Math.max(3, parseFloat(root.getAttribute('data-vt-speed')) || 6) * 1000;
    var timer = null;
    var idle = null;
    var raf = 0;
    var userPaused = false;
    var hover = false;
    var focus = false;
    var touch = false;
    var inView = true;
    var motion = !!root.querySelector('.is-hl, .vt-dot');

    function slides() { return toArray(track.children).filter(function (li) { return !li.hidden; }); }
    function maxX() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function step() {
      var s = slides();
      return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : track.clientWidth;
    }
    function go(x) {
      var b = reduced() ? 'auto' : 'smooth';
      try { track.scrollTo({ left: x, behavior: b }); } catch (e) { track.scrollLeft = x; }
    }
    function canPlay() {
      return autoplay && !reduced() && !userPaused && !hover && !focus && !touch && inView && !document.hidden && maxX() > 4;
    }
    function schedule() {
      clearTimeout(timer);
      timer = null;
      if (canPlay()) timer = setTimeout(advance, delay);
    }
    function advance() {
      timer = null;
      if (!canPlay()) return;
      var x = track.scrollLeft;
      if (x >= maxX() - 4) go(0);
      else go(Math.min(maxX(), x + step()));
    }
    function syncToggle() {
      if (!toggle) return;
      var auto = autoplay && !reduced() && maxX() > 4;
      toggle.hidden = reduced() || !(auto || motion);
      toggle.classList.toggle('is-paused', userPaused);
      root.classList.toggle('is-paused', userPaused);
      toggle.setAttribute('aria-label', auto
        ? (userPaused ? 'Automatisches Weiterblättern starten' : 'Automatisches Weiterblättern anhalten')
        : (userPaused ? 'Animation fortsetzen' : 'Animation anhalten'));
    }
    function update() {
      raf = 0;
      var x = track.scrollLeft;
      var m = maxX();
      var scrollable = m > 4;
      root.classList.toggle('vt-is-static', !scrollable);
      if (back) back.disabled = !scrollable || x <= 4;
      if (fwd) fwd.disabled = !scrollable || x >= m - 4;
      if (thread) {
        var ratio = scrollable ? (x + track.clientWidth) / track.scrollWidth : 1;
        thread.style.setProperty('--vt-progress', Math.min(1, ratio).toFixed(4));
      }
      syncToggle();
    }
    function onScroll() {
      if (!raf) raf = window.requestAnimationFrame(update);
      clearTimeout(idle);
      idle = setTimeout(schedule, 220);
    }

    on(track, 'scroll', onScroll, { passive: true }, cleanup);
    on(back, 'click', function () { go(Math.max(0, track.scrollLeft - step())); }, false, cleanup);
    on(fwd, 'click', function () { go(Math.min(maxX(), track.scrollLeft + step())); }, false, cleanup);
    on(toggle, 'click', function () {
      userPaused = !userPaused;
      if (!userPaused) { hover = false; focus = false; }
      syncToggle();
      if (!userPaused && canPlay()) advance();
      else schedule();
    }, false, cleanup);
    on(root, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; schedule(); } }, false, cleanup);
    on(root, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; schedule(); } }, false, cleanup);
    on(root, 'focusin', function () { focus = true; schedule(); }, false, cleanup);
    on(root, 'focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) { focus = false; schedule(); }
    }, false, cleanup);
    on(track, 'touchstart', function () { touch = true; schedule(); }, { passive: true }, cleanup);
    on(track, 'touchend', function () { touch = false; schedule(); }, { passive: true }, cleanup);
    on(track, 'touchcancel', function () { touch = false; schedule(); }, { passive: true }, cleanup);
    on(document, 'visibilitychange', schedule, false, cleanup);
    if (mqReduce && mqReduce.addEventListener) on(mqReduce, 'change', function () { update(); schedule(); }, false, cleanup);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.35 });
      io.observe(root);
      cleanup.push(function () { io.disconnect(); });
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { update(); });
      ro.observe(track);
      cleanup.push(function () { ro.disconnect(); });
    } else {
      on(window, 'resize', update, false, cleanup);
    }
    cleanup.push(function () { clearTimeout(timer); clearTimeout(idle); if (raf) window.cancelAnimationFrame(raf); });

    update();
    schedule();
  }

  /* ---------- Start ---------- */
  function each(scope, sel, fn) {
    if (!scope) return;
    if (scope.matches && scope.matches(sel)) fn(scope);
    toArray(scope.querySelectorAll ? scope.querySelectorAll(sel) : []).forEach(fn);
  }
  function initAll(scope) {
    each(scope || document, '[data-vt-page]', initPage);
    each(scope || document, '[data-vt-widget]', initWidget);
  }
  function destroyAll(scope) {
    each(scope, '[data-vt-page], [data-vt-widget]', function (r) {
      if (r.__vt) { r.__vt.destroy(); r.__vt = null; }
    });
  }

  window.LutterlohVT = { initAll: initAll };
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();